/* istanbul ignore file */

import { Option, SelectBox } from '@idexx-laboratories/spot-react';
import React, { ComponentPropsWithoutRef } from 'react';
import './SelectBoxOptions.scss';

interface SelectBoxOptionsProps extends Omit<ComponentPropsWithoutRef<'select'>, 'onChange'> {
  groupClassName?: string;
  values: any[];
  disabledIndices?: any[];
  displayField?: string;
  disabled?: boolean;
  label?: string;
  inCell?: boolean;
  error?: boolean;
  onChange: (index: number) => void;
  formatter?: (v: any) => string;
  selectedIndex: number;
}

const SelectBoxOptions = (props: SelectBoxOptionsProps): React.JSX.Element => {
  const { values, disabledIndices, selectedIndex, formatter, onChange, displayField, ...rest } =
    props;

  const formatValue = (value: any) =>
    formatter ? formatter(value) : displayField ? value[displayField] : value;

  return (
    <SelectBox
      onChange={e => onChange(parseInt(e.target.value))}
      value={String(selectedIndex)}
      role='select'
      {...rest}
    >
      {selectedIndex === -1 && <Option value='-1'>&nbsp;</Option>}
      {values.map((value, index) => (
        <Option
          className='spot-form__select-option'
          value={index}
          key={displayField ? value[displayField] : value}
          disabled={disabledIndices?.includes(index)}
          data-testid={`${rest['data-testid']}-${formatValue(value)}-option`}
        >
          {formatValue(value)}
        </Option>
      ))}
    </SelectBox>
  );
};

export default SelectBoxOptions;
